import { render, staticRenderFns } from "./DealsFase.vue?vue&type=template&id=46c943dc&"
import script from "./DealsFase.vue?vue&type=script&lang=js&"
export * from "./DealsFase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports